import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "row justify-left full-width q-py-none no-wrap" }
const _hoisted_2 = { class: "col" }
const _hoisted_3 = {
  style: {"position":"relative"},
  class: "row justify-left full-width q-py-none no-wrap"
}
const _hoisted_4 = { class: "fs-menu__content" }
const _hoisted_5 = { class: "fs-menu__group-label" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 2,
  class: "fs-menu__group-label fs-menu__group-label--next"
}
const _hoisted_8 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_selector_search_header = _resolveComponent("selector-search-header")!
  const _component_recursive_selector = _resolveComponent("recursive-selector")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_select = _resolveComponent("q-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (!_ctx.readOnly)
          ? (_openBlock(), _createBlock(_component_q_btn, {
              key: 0,
              class: "q-my-none q-pa-none text-left text-md unset-items-center",
              flat: "",
              "no-caps": "",
              align: "left",
              size: "xs",
              color: "grey-8",
              icon: "code",
              "aria-label": _ctx.$t('choose_upcase')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_tooltip, {
                  delay: 300,
                  anchor: "top middle",
                  self: "center middle"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('select_parameter')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_menu, {
                  class: "fs-menu",
                  modelValue: _ctx.selectorOpen,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.selectorOpen) = $event)),
                  onBeforeShow: _cache[9] || (_cache[9] = (e) => { _ctx.filter_string = '' }),
                  onShow: _ctx.focusSearchField
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_selector_search_header, {
                      ref: "searchHeader",
                      modelValue: _ctx.filter_string,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filter_string) = $event)),
                      "show-close-button": true,
                      "use-own-clear-button": true,
                      onKeyDown: _cache[1] || (_cache[1] = ($event: any) => (_ctx.first_selector && (_ctx.first_selector as any).trackArrowDown(1))),
                      onKeyUp: _cache[2] || (_cache[2] = ($event: any) => (_ctx.first_selector && (_ctx.first_selector as any).trackArrowUp(1))),
                      onKeyEnter: _cache[3] || (_cache[3] = ($event: any) => (_ctx.first_selector && (_ctx.first_selector as any).selectCurrent())),
                      onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectorOpen = false))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, _toDisplayString(!_ctx.globalFormulasMode ? _ctx.$t('parameters') : _ctx.$t('formulas')), 1),
                      (_ctx.inputParameterOptions && _ctx.inputParameterOptions.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.inputParameterOptions, (opts, op_key) => {
                              return (_openBlock(), _createBlock(_component_recursive_selector, {
                                class: _normalizeClass(_ctx.globalFormulasMode && op_key === 0 ? 'fs-menu__group--divided' : ''),
                                ref_for: true,
                                ref: (el) => { _ctx.divs[op_key] = el },
                                key: op_key,
                                elements: opts,
                                "take-ids-only": true,
                                "hide-checkboxes": true,
                                "allow-multiple": false,
                                "show-records": true,
                                "element-type": 9,
                                modelValue: _ctx.selectedParameterModel,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedParameterModel) = $event)),
                                "return-type": "chain",
                                "nested-key-name": _ctx.nestedKeyName,
                                "entity-inside-name": _ctx.templateName,
                                "filter-string": _ctx.filter_string
                              }, null, 8, ["class", "elements", "modelValue", "nested-key-name", "entity-inside-name", "filter-string"]))
                            }), 128))
                          ]))
                        : (_ctx.columnParameterOptions && _ctx.columnParameterOptions.length)
                          ? (_openBlock(), _createBlock(_component_recursive_selector, {
                              key: 1,
                              ref: "rec_selector",
                              elements: _ctx.columnParameterOptions,
                              "take-ids-only": true,
                              "hide-checkboxes": true,
                              "allow-multiple": false,
                              "element-type": 1,
                              modelValue: _ctx.selectedColumnParameterModel,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedColumnParameterModel) = $event)),
                              "is-column": true,
                              "filter-string": _ctx.filter_string
                            }, null, 8, ["elements", "modelValue", "filter-string"]))
                          : _createCommentVNode("", true),
                      (!_ctx.globalFormulasMode)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.$t('formulas')), 1))
                        : _createCommentVNode("", true),
                      (_ctx.formulaOptions && _ctx.formulaOptions.length)
                        ? (_openBlock(), _createBlock(_component_recursive_selector, {
                            key: 3,
                            ref: "rec_selector",
                            elements: _ctx.formulaOptions,
                            "take-ids-only": true,
                            "hide-checkboxes": true,
                            "allow-multiple": false,
                            "element-type": 1,
                            modelValue: _ctx.selectedFormulaModel,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selectedFormulaModel) = $event)),
                            "filter-string": _ctx.filter_string
                          }, null, 8, ["elements", "modelValue", "filter-string"]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "onShow"])
              ]),
              _: 1
            }, 8, ["aria-label"]))
          : _createCommentVNode("", true),
        (!_ctx.readOnly)
          ? (_openBlock(), _createBlock(_component_q_select, {
              key: 1,
              modelValue: _ctx.innerFormulaModel,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.innerFormulaModel) = $event)),
              ref: "formula_field",
              class: "formula-input",
              outlined: "",
              dense: "",
              autogrow: "",
              "use-input": "",
              "hide-bottom-space": "",
              multiple: "",
              "no-error-icon": "",
              "input-debounce": "500",
              placeholder: _ctx.displayFormulaStr ? '' : _ctx.$t('empty_at_all'),
              "error-message": _ctx.isIncorrect,
              error: _ctx.isIncorrect ? true : false,
              "display-value": _ctx.displayFormulaStr,
              "display-value-html": true,
              "use-chips": false,
              "hide-dropdown-icon": true,
              options: _ctx.combinedOptions,
              onFilter: _ctx.filterInput,
              onAdd: _ctx.addFormulaFunc,
              onNewValue: _ctx.addFormulaToken,
              onKeydown: _withKeys(_withModifiers(() => {}, ["stop","prevent"]), ["esc"]),
              onKeyup: _withKeys(_withModifiers(_ctx.resetFormula, ["stop","prevent"]), ["esc"]),
              onBlur: _ctx.onBlur
            }, null, 8, ["modelValue", "placeholder", "error-message", "error", "display-value", "options", "onFilter", "onAdd", "onNewValue", "onKeydown", "onKeyup", "onBlur"]))
          : (_openBlock(), _createElementBlock("div", {
              key: 2,
              innerHTML: _ctx.displayFormulaStr
            }, null, 8, _hoisted_8))
      ])
    ])
  ]))
}